"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseLayer = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const GameState_1 = require("../Core/GameState");
const GameConfig_1 = require("../Core/GameConfig");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const InfoSprite_1 = require("../Common/InfoObject/InfoSprite");
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const Constants_1 = require("../Core/Constants");
let PauseLayer = class PauseLayer extends pixi_js_1.Container {
    constructor(state, config, resources, events) {
        super();
        const mask = new pixi_js_1.Sprite(pixi_js_1.Texture.WHITE);
        mask.tint = 0;
        mask.alpha = 0.5;
        const container = new FixRatioContainer_1.FixRatioContainer(Constants_1.LayerWidth, Constants_1.LayerHeight);
        mask.width = events.Resize.prevArgs[0];
        mask.height = events.Resize.prevArgs[1];
        container.resize(...events.Resize.prevArgs);
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            mask.width = w;
            mask.height = h;
            container.resize(w, h);
        });
        mask.interactive = true;
        mask.on("pointertap", (e) => e.stopPropagation());
        this.addChild(mask);
        this.addChild(container);
        const info = resources.ui.data.info.pause;
        const textures = resources.ui.textures;
        if (info.other instanceof Array) {
            for (const x of info.other) {
                this.addChild(new InfoSprite_1.InfoSprite(x, textures));
            }
        }
        const continuebtn = new InfoSprite_1.InfoSprite(info.continue, textures);
        const restart = new InfoSprite_1.InfoSprite(info.restart, textures);
        const back = new InfoSprite_1.InfoSprite(info.back, textures);
        continuebtn.interactive = true;
        //        continuebtn.buttonMode = true
        continuebtn.once("pointertap", () => {
            state.on.continue.emit();
        });
        restart.interactive = true;
        //        restart.buttonMode = true
        restart.once("pointertap", () => {
            state.on.restart.emit();
        });
        back.interactive = true;
        //        back.buttonMode = true
        back.once("pointertap", () => {
            state.on.abort.emit();
        });
        container.addChild(continuebtn, restart, back);
        events.Update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            for (const x of this.children) {
                if (x instanceof InfoSprite_1.InfoSprite) {
                    x.update(dt);
                }
            }
        });
    }
};
PauseLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState, GameConfig_1.GameConfig, SymbolClasses_1.Resources, SymbolClasses_1.GlobalEvents])
], PauseLayer);
exports.PauseLayer = PauseLayer;
//# sourceMappingURL=PauseLayer.js.map